export const GET_REQUIREMENTS_FULL_LIST = 'GET_REQUIREMENTS_FULL_LIST'
